(() => {
  const callback = () => {
    if (!window.themeComponents.snippets.register('featured-collection')) return;

    const selectors = {
      wrapper: '.featured-collection',
      swiper: '.swiper',
      swiperSlide: '.swiper-slide',
      swiperButtonNext: '.swiper-button-next',
      swiperButtonPrev: '.swiper-button-prev',
      imageWrapper: '.grid__item-image-wrapper',
      viewAllSlide: '.featured-collection__view-all',
    };

    const updateSlidesPerView = (swiper) => {
      const { slidesPerView } = swiper.el.dataset;
      if (!slidesPerView) return;

      swiper.params.breakpoints['769'].slidesPerView = slidesPerView;
      swiper.update();
    };

    const toggleViewAllSlide = (swiper) => {
      const viewAllSlide = swiper.el.querySelector(selectors.viewAllSlide);
      if (!viewAllSlide) return;

      const slides = swiper.el.querySelectorAll(selectors.swiperSlide);
      const hasSlidesToScroll = slides.length - 1 > swiper.params.slidesPerView;
      viewAllSlide.classList.toggle('hidden', !hasSlidesToScroll);
      swiper.update();
    };

    const alignNavButtons = (swiper) => {
      const imageWrapper = swiper.el.querySelector(selectors.imageWrapper);
      if (!imageWrapper) return;

      const buttonsTopOffset = imageWrapper.offsetHeight / 2;
      swiper.el.style.setProperty('--swiper-navigation-top-offset', `${buttonsTopOffset}px`);
    };

    const initSlider = ({ targetSection } = {}) => {
      const targetSelector = targetSection ? `#${targetSection.getAttribute('id')}` : '';
      const queryString = `${targetSelector} ${selectors.wrapper} ${selectors.swiper}`;

      new Swiper(queryString, {
        slidesPerView: 2.1,
        slidesPerGroup: 1,
        spaceBetween: 5,
        freeMode: {
          enabled: true,
          sticky: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: selectors.swiperButtonNext,
          prevEl: selectors.swiperButtonPrev,
        },
        breakpoints: {
          769: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        },
        on: {
          beforeInit: function () {
            updateSlidesPerView(this);
          },

          breakpoint: function () {
            updateSlidesPerView(this);
            toggleViewAllSlide(this);
          },

          resize: function () {
            alignNavButtons(this);
          },
        },
      });
    };
    initSlider();

    document.addEventListener('shopify:section:load', (event) => initSlider({ targetSection: event.target }));
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
